<template>
  <div class="background-wrapper">
    <Hero />
    <groupBuying />
    <!-- table -->

    <div class="page-help content ">
      <!--  <div class="hMain">{{ $t("franchise.hMain") }}</div>
        <div class="wrappHero">
          <div class="heroTxt">
            <p class="txt" v-html="$t('franchise.txt1')"></p>
            <p class="title" v-html="$t('franchise.h')"></p>
            <p class="txt" v-html="$t('franchise.txt2')"></p>
            <p class="txt" v-html="$t('franchise.txt3')"></p>
            <p class="txt" v-html="$t('franchise.txt4')"></p>
          </div>
          <div class="hero">
            <img src="../assets/images/franchiseHero.jpg" alt="" />
          </div>
        </div> -->
      <div class="rules">{{ $t("newFranchise.rules") }}</div>
      <div class="rules-txt">{{ $t("newFranchise.rulesTxt") }}</div>

      <img
        v-if="showLoader"
        :src="require('@/assets/images/loader.gif')"
        alt=""
        class="spiner-img"
      />
      <div class="table" v-else>
        <div class="row th">
          <td>{{ $t("main.documentName") }}</td>
          <div class="action">
            <td>{{ $t("newFranchise.read") }}</td>
            <td>{{ $t("newFranchise.download") }}</td>
          </div>
        </div>

        <div v-for="(doc, index) in documents" :key="index" class="row tr">
          <td>{{ doc.frd_name }}</td>
          <div class="action">
            <td v-if="doc.frd_type !== 'DOC'">
              <a class="link" :href="generatePreviewLink(doc)" target="_blank">
                <div class="icon-wrapper">
                  <img src="@/assets/newImges/eye.svg" alt="preview icon" />
                </div>
              </a>
            </td>
            <td v-else></td>
            <td>
              <a class="link" :href="generateDownloadLink(doc)">
                <div class="icon-wrapper">
                  <img
                    src="@/assets/newImges/download.svg"
                    alt="preview icon"
                  />
                </div>
              </a>
            </td>
          </div>
        </div>
      </div>
    </div>

    <ContactUs txt="newFranchise.formTxt" page="franchise" />
    <!-- <table v-else>
        <thead>
          <tr>
            <td></td>
            <td>{{ $t("main.documentName") }}</td>
            <td>{{ $t("newFranchise.read") }}</td>
            <td>{{ $t("newFranchise.download") }}</td>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(doc, index) in documents" :key="index">
            <td>

            </td>
            <td>{{ doc.frd_name }}</td>
            <td v-if="doc.frd_type !== 'DOC'" style="width:50px">
              <a class="link" :href="generatePreviewLink(doc)" target="_blank">
                <div class="icon-wrapper">
                  <img src="@/assets/newImges/eye.svg" alt="preview icon" />
                </div>
              </a>
            </td>
            <td v-else></td>
            <td style="width:60px">
              <a class="link" :href="generateDownloadLink(doc)">
                <div class="icon-wrapper">
                  <img
                    src="@/assets/newImges/download.svg"
                    alt="preview icon"
                  />
                </div>
              </a>
            </td>
          </tr>
        </tbody>
      </table> -->

    <!-- end table AND PAGE HELP-->
  </div>
</template>

<script>
import { api, baseURL } from "@/api";
import Hero from "@/components/franchise/Hero.vue";
import groupBuying from "@/components/franchise/groupBuying.vue";
import ContactUs from "../components/homeNew/ContactUs.vue";

export default {
  name: "Franchise",
  components: {
    Hero,
    groupBuying,
    ContactUs
  },
  data() {
    return {
      documents: [],
      showLoader: false
    };
  },
  mounted() {
    this.getListFranchise();
  },
  activated() {
    this.getListFranchise();
  },
  methods: {
    getListFranchise() {
      this.showLoader = true;
      window.scrollTo({ top: 0, behavior: "smooth" });

      api
        .getListFranchise()
        .then(res => {
          console.log(res);
          this.documents = res.data.data;
          this.showLoader = false;
        })
        .catch(e => {
          this.showLoader = false;
          console.log(e);
        });
    },
    generatePreviewLink(doc) {
      return baseURL + `/franchise/franchise/${doc.frd_id}/document`;
    },
    generateDownloadLink(doc) {
      return baseURL + `/franchise/franchise/${doc.frd_id}/download`;
    }
  },
  watch: {
    // '$i18n.locale': {
    //   handler (newLocale, oldLocale) {
    //     if (newLocale !== oldLocale) {
    //       this.getListFranchise()
    //     }
    //   }
    // }
  }
};
</script>

<style lang="scss" scoped>
.background-wrapper {
  background-color: $gray-blue-100;
  width: 100%;
  font-family: Outfit;
  background-image: url("../assets/newImges/EllipseRight.png") !important;
  background-repeat: no-repeat;
  background-position: right 55%;
}
.spiner-img {
  width: 150px;
}

.content {
  text-align: left;
  // table {
  //   border: none;
  //   width: 100%;
  //   // max-width: 1020px;
  //   border-collapse: collapse;

  //   thead {
  //     td {
  //       padding: 5px;
  //       box-sizing: border-box;
  //       text-align: left;
  //       height: 65px;
  //       border: none;
  //       font-weight: 500;
  //       font-style: Medium;
  //       font-size: 20px;
  //       line-height: 30px;
  //       letter-spacing: 0%;
  //       color: $gray-blue-1300;
  //     }
  //   }
  //   tbody {
  //     tr {
  //       margin-bottom: 20px;
  //       border: 1px solid #e8e8e8;
  //       border-radius: 11px !important;
  //       td {
  //         padding: 5px;
  //         box-sizing: border-box;
  //         text-align: left;
  //         height: 60px;

  //         font-weight: 600;
  //         font-size: 15px;
  //         line-height: 25px;
  //         letter-spacing: 0.06em;
  //         color: #606060;

  //         .icon-wrapper {
  //           display: flex;
  //           align-items: center;
  //           justify-content: center;
  //           cursor: pointer;
  //         }
  //       }
  //     }
  //     tr:last-child {
  //       td {
  //         border-bottom: none;
  //       }
  //     }
  //   }
  // }

  .rules {
    font-weight: 600;
    font-style: SemiBold;
    font-size: 36px;
    line-height: 66px;
    letter-spacing: 0%;
    color: $blue-1000;
    margin-bottom: 30px;
  }
  .rules-txt {
    font-weight: 600;
    font-style: SemiBold;
    font-size: 20px;
    line-height: 32px;
    letter-spacing: 0%;
    color: $blue-1000;
    margin-bottom: 56px;
    max-width: 1240px;
  }
  .row,
  .action,
  td {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  .action {
    width: 15%;
    min-width: 155px;
    td {
      width: 50%;
      display: flex;
      justify-content: center;
    }
  }

  .th {
    padding: 24px;
    td {
      box-sizing: border-box;
      text-align: left;

      border: none;
      font-weight: 500;
      font-style: Medium;
      font-size: 20px;
      line-height: 30px;
      letter-spacing: 0%;
      color: $gray-blue-1300;
    }
  }

  .tr {
    margin-bottom: 20px;
    border: 1px solid #e8e8e8;
    border-radius: 11px !important;
    padding: 24px;
    background-color: $gray-blue-100;
    td {
      box-sizing: border-box;
      text-align: left;

      font-weight: 400;
      font-style: Regular;
      font-size: 25px;
      line-height: 100%;
      letter-spacing: 0%;

      .icon-wrapper {
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
      }
    }
  }
  // .tr:last-child {
  //   td {
  //     border-bottom: none;
  //   }
  // }
}

// @media only screen and (max-width: 1200px) {
//   .content {
//     margin: auto;
//   }
// }

@media only screen and (max-width: 750px) {
  .background-wrapper {
    background-position: right 60%;
  }
  .content {
    .rules {
      font-size: 36px;
      line-height: 46px;
      margin-bottom: 30px;
    }
    .rules-txt {
      font-size: 18px;
      line-height: 26px;
      margin-bottom: 56px;
    }
    .th,
    .tr {
      padding: 14px;
    }
    .th {
      td {
        font-size: 16px;
        line-height: 20px;
      }
    }

    .tr {
      margin-bottom: 15px;

      td {
        font-weight: 400;
        font-style: Regular;
        font-size: 16px;
        line-height: 20px;
      }
    }
  }
}
</style>
